import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=4e8afffe&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8afffe')) {
      api.createRecord('4e8afffe', component.options)
    } else {
      api.reload('4e8afffe', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=4e8afffe&", function () {
      api.rerender('4e8afffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fc7LMPXp1UAd/JS/comp/stardisplay.vue"
export default component.exports